import { render, staticRenderFns } from "./NewFamilyApplications.vue?vue&type=template&id=3c841cca&"
import script from "./NewFamilyApplications.vue?vue&type=script&lang=js&"
export * from "./NewFamilyApplications.vue?vue&type=script&lang=js&"
import style0 from "./NewFamilyApplications.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports